import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@images/right-arrow-orange.svg';
const _withScopeId = n => (_pushScopeId("data-v-3ebdd45e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "row" };
const _hoisted_2 = { class: "article-title py-4 mt-3 mb-3" };
const _hoisted_3 = ["href", "title"];
const _hoisted_4 = ["href"];
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    class: "arrow",
    src: _imports_0,
    alt: "Right arrow",
    loading: "lazy"
}, null, -1));
const _hoisted_6 = [
    _hoisted_5
];
const _hoisted_7 = ["src", "alt"];
export default /*#__PURE__*/ _defineComponent({
    __name: 'article_carousel_item',
    props: ['d'],
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_badge = _resolveComponent("badge");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["article_item", { 'article_item__shadow': __props.d.shadow }])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["col-lg-6 article_item__content order-sm-1", { 'order-lg-2': __props.d.align == 'left' }])
                    }, [
                        _createVNode(_component_badge, {
                            isLarge: "",
                            content: [__props.d.article.category.title]
                        }, null, 8, ["content"]),
                        _createElementVNode("h3", _hoisted_2, [
                            _createElementVNode("a", {
                                href: __props.d.article.alias,
                                title: __props.d.article.title,
                                class: "no-style"
                            }, _toDisplayString(__props.d.article.title), 9, _hoisted_3)
                        ]),
                        _createElementVNode("a", {
                            class: "no-style",
                            href: __props.d.article.alias
                        }, _hoisted_6, 8, _hoisted_4)
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["col-lg-6 article_item__image order-sm-2", { 'order-lg-1': __props.d.align == 'left' }])
                    }, [
                        _createElementVNode("img", {
                            src: __props.d.article.image,
                            alt: __props.d.article.title,
                            loading: "lazy"
                        }, null, 8, _hoisted_7)
                    ], 2)
                ])
            ], 2));
        };
    }
});
